import { render, staticRenderFns } from "./AButtonShare.vue?vue&type=template&id=a0bfb11e&"
import script from "./AButtonShare.vue?vue&type=script&lang=js&"
export * from "./AButtonShare.vue?vue&type=script&lang=js&"
import style0 from "./AButtonShare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VFabTransition,VIcon,VSpeedDial})
